
import { takeLatest, call, put, select } from 'redux-saga/effects';
import { hotelActionTypes } from './hotelTypes';
import { hotelApiResponseError, hotelApiResponseSuccess } from './hotelActions'
import { showErrorNotification, showSuccessNotification } from "../../helpers/NotificationContext";
import { insertHotelApi, updateHotelApi, getHotelApi } from 'src/api/hotel';
import { deleteHotelDataApi } from 'src/api/hotel';




function* insertHotelSaga(action: any) {
    try {
        console.log("[insertHotelSaga] action.payload", action.payload);

        const payload = action.payload;
        console.log("insertHotelSaga sending payload to api:", payload);
        const response = yield call(insertHotelApi, payload);
        console.log("Backend response from insertHotelSaga: ", response);
        yield put(hotelApiResponseSuccess(hotelActionTypes.INSERT_HOTEL, response));
        showSuccessNotification(`🚀 Details fetched successfully!`);

    } catch (error: any) {
        console.error(" insertHotelSaga Saga error ", error.message);
        yield put(hotelApiResponseError(hotelActionTypes.INSERT_HOTEL, error.message));
        showErrorNotification("Execution failed: " + error.message);
    }
}



function* updateHotelSaga(action: any) {
    try {
        console.log("[updateHotelSaga] action.payload", action.payload);

        const payload = action.payload;
        console.log("updateHotelSaga sending payload to api:", payload);
        const response = yield call(updateHotelApi, payload);
        console.log("Backend response from updateHotelSaga: ", response);
        yield put(hotelApiResponseSuccess(hotelActionTypes.UPDATE_HOTEL, response));
        showSuccessNotification(`🚀 Details fetched successfully!`);

    } catch (error: any) {
        console.error(" updateHotelSaga Saga error ", error.message);
        yield put(hotelApiResponseError(hotelActionTypes.UPDATE_HOTEL, error.message));
        showErrorNotification("Execution failed: " + error.message);
    }
}



function* getHotelSaga(action: any) {
    try {
        console.log("[getHotelSaga] action.payload", action.payload);

        const payload = action.payload;
        console.log("getHotelSaga sending payload to api:", payload);
        const response = yield call(getHotelApi);
        console.log("Backend response from getHotelSaga: ", response);
        // yield put(hotelApiResponseSuccess(hotelActionTypes.GET_HOTEL, response));
        // showSuccessNotification(`🚀 Details fetched successfully!`);


        if (response.error) {
            console.log("response error case triggeerd");
            yield put(hotelApiResponseError(hotelActionTypes.GET_HOTEL, response.response.error));

            showErrorNotification("Execution failed: " + response.response.message);
        } else {
            yield put(hotelApiResponseSuccess(hotelActionTypes.GET_HOTEL, response));
            showSuccessNotification(`🚀 Details fetched successfully!`);

        }

    } catch (error: any) {
        console.error(" getHotelSaga Saga error ", error.message);
        yield put(hotelApiResponseError(hotelActionTypes.GET_HOTEL, error.message));
        showErrorNotification("Execution failed: " + error.message);
    }
}

function* deleteHotelDataSaga(action: any) {
    try {
        console.log("[deleteHotelDataSaga] action.payload", action.payload);

        const payload = action.payload;
        console.log("deleteHotelDataSaga sending payload to api:", payload);
        const response = yield call(deleteHotelDataApi, payload);
        console.log("Backend response from deleteHotelDataSaga: ", response);
        yield put(hotelApiResponseSuccess(hotelActionTypes.DELETE_HOTEL_DATA, response));
        showSuccessNotification(`🚀 Details fetched successfully!`);

    } catch (error: any) {
        console.error(" deleteHotelDataSaga Saga error ", error.message);
        yield put(hotelApiResponseError(hotelActionTypes.DELETE_HOTEL_DATA, error.message));
        showErrorNotification("Execution failed: " + error.message);
    }
}





export default function* hotelSaga() {
    yield takeLatest(hotelActionTypes.INSERT_HOTEL, insertHotelSaga);
    yield takeLatest(hotelActionTypes.UPDATE_HOTEL, updateHotelSaga);
    yield takeLatest(hotelActionTypes.GET_HOTEL, getHotelSaga);

    yield takeLatest(hotelActionTypes.DELETE_HOTEL_DATA, deleteHotelDataSaga);





}
